/**
 * Credit costs for web-app document actions, shown on buttons BEFORE the
 * click — a user must never learn a price by paying it.
 *
 * These mirror the server-side cost tables (`_WEB_ACTION_COSTS` and
 * `_WEB_REGISTER_DOWNLOAD_COST` in the backend's `backend/server/public.py`);
 * the backend is authoritative and the client only ever names the action,
 * so a drift here mislabels a button but can never change what is billed.
 */
export const WEB_CREDIT_COSTS = {
  /**
   * Opening a Bilanz in the in-page viewer (`bilanz_view`). Same price as
   * every other document, and ONE purchase with the HTML export: owning
   * either access mode owns the document (backend `_BILANZ_ACTIONS`), so
   * view-then-export never bills twice.
   */
  bilanzView: 10,
  /** Exporting the opened Bilanz as HTML (`bilanz_html_download`). */
  bilanzHtmlDownload: 10,
  /** Register file download / refresh (SI, CD, AD, DK …). */
  registerFileDownload: 60,
} as const;
